import { captureException } from '@sentry/browser';
import Router from 'vue-router';

import ROUTES from '@/constants/routes';
import store from '@/store';
import bus from '@/plugins/bus';
import { log } from '@/plugins/debugging';

function convertRoutes(routes) {
  return Object.entries(routes).map(([key, value]) => ({
    ...value,
    name: key, // Set object name as route name
    meta: routes[key].meta || {}, // Make sure every route contains 'meta'
    children: value.children && convertRoutes(value.children),
  }));
}

const router = new Router({
  mode: 'history',
  routes: convertRoutes(ROUTES),
});

router.beforeEach(async (to, from, next) => {
  window.scroll({
    top: 0,
    left: 0,
    right: 0,
    behavior: 'smooth',
  });

  const isAppInitialized = store.state.isLoggedIn !== null;
  const isLoggedIn = store.state.isLoggedIn === true;
  const { adminOnly, noLoginRequired } = to.meta;
  const isRouteForbidden = adminOnly && !store.state.user.isAdmin;

  // Dont check any state if no login is required. Go to next route.
  if (noLoginRequired) {
    log('noLoginRequired === true');
    next();
    return;
  }

  // If login is required, make sure state is set by fetching from server by
  // checking "isAppInitialized"
  if (!isAppInitialized) {
    log('isAppInitialized === false');
    // If app is not initialized, wait with routing until 'authenticated' is emitted
    bus.$once('authenticated', () => {
      next();
    });

    // Not calling next will leave app blank.
    // Call next after 5 seconds to make sure router doesnt get stuck. You never know.
    setTimeout(next, 5000);
    return;
  }

  // If user is not allowed to route, redirect to forbidden page.
  if (isRouteForbidden) {
    log('isRouteForbidden === true');
    bus.$emit('notification', 'Forbidden url');
    captureException(`User entered the forbidden route: ${to.fullPath}`);
    next({ name: 'forbidden' });
    return;
  }

  if (!isLoggedIn) {
    log('isLoggedIn === false');
    bus.$emit('notification', 'Please login');
    // Navigation is not oki, user should login:
    // adding next search parameter allows the login page
    // to redirect to the request page after login
    next({ name: 'login', params: { next: to.path } });
    return;
  }

  // all good!
  next();
});

export default router;
